import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Footer from './Footer';
import AuthModal from './AuthModal';
import ChatDrawer from './ChatDrawer';
import PwaInstallBanner from '../common/PwaInstall';
import CookieConsent from '../common/CookieConsent';
import { useAuth } from '../../contexts/AuthContext';

export default function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem('nuyed_sidebar_collapsed') === '1'; } catch { return false; }
  });
  useAuth();

  useEffect(() => {
    document.body.classList.toggle('gx-sidebar-collapsed', collapsed);
    try { localStorage.setItem('nuyed_sidebar_collapsed', collapsed ? '1' : '0'); } catch {}
  }, [collapsed]);

  return (
    <div className="min-h-screen">
      <div className="fixed inset-0 -z-10 bg-gx-bg pointer-events-none" />
      <div className="fixed inset-0 -z-10 pointer-events-none opacity-[.18]" style={{ backgroundImage: 'radial-gradient(ellipse 60% 40% at 15% 0%, rgba(35,136,255,0.35) 0%, transparent 60%),radial-gradient(ellipse 50% 40% at 90% 100%, rgba(109,40,255,0.25) 0%, transparent 60%)' }} />

      <Sidebar collapsed={collapsed} onToggleCollapse={() => setCollapsed((c) => !c)} mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
      <Topbar onToggleMobile={() => setMobileOpen((o) => !o)} />

      <div className="gx-content md:pl-64 pt-16 transition-[padding] duration-300">
        <main className="px-4 md:px-8 py-5 md:py-7 max-w-[1600px] mx-auto">
          <Outlet />
        </main>
        <Footer />
      </div>

      <ChatDrawer />
      <PwaInstallBanner />
      <CookieConsent />
      <AuthModal />
    </div>
  );
}
